import React from "react";
import { Helmet } from "react-helmet-async";
import { SEOConfig } from "../../utils/seoConfig";

interface SEOHeadProps {
  seo: SEOConfig;
  canonicalUrl?: string;
}

export const SEOHead: React.FC<SEOHeadProps> = ({ seo, canonicalUrl }) => {
  const siteUrl = window.location.origin;
  const url = canonicalUrl || siteUrl + window.location.pathname;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={seo.ogTitle || seo.title} />
      <meta property="og:description" content={seo.ogDescription || seo.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      {seo.ogImage && <meta property="og:image" content={seo.ogImage} />}
      
      {/* Twitter Card Tags */}
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      {seo.ogImage && <meta name="twitter:image" content={seo.ogImage} />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEOHead;
